<template>
    <div class="footer-mobile" v-if="setup != null" id="footer-mobile">
        <div class="footer-contacts-items">
            <div class="footer-contacts" v-if="!reverse">
                <div class="item" v-for="item in setup.footer_contacts">
                    <div class="item-icon">
                        <svgIcon name="pin-footer" class="icon-pin-footer"/>
                    </div>
                    <div class="adres">
                        <div class="top">
                            {{item.region}}
                        </div>
                        <p>{{item.adres}}</p>
                    </div>
                    <div class="phone">
                        <a :href="'tel:' + item.phone">{{item.phone}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-social">
            <h3>
                <svgIcon name="social-footer" class="icon-social-footer"/>
                <span>Bazis-A в социальных сетях</span>
            </h3>
            <div class="social-items">
                <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                    <svgIcon name="instagram" class="icon-instagram"/>
                </a>
                <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                    <svgIcon name="facebook" class="icon-facebook"/>
                </a>
                <!-- <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                    <svgIcon name="telegram" class="icon-telegram"/>
                </a> -->
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'AppFooter',
        data () {
            return {
                reverse: false,
                lang: window.GlobalLang,
            }
        },
        components: {
            svgIcon,
        },
        methods: {
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/respond/footer/footer-respond.scss';
</style>